// PRO Portfolio Drift & Rebalancing Alpha Auditor -- protected dashboard page.
//
// Mounted at /dashboard/portfolio-drift-auditor-pro behind <ProtectedRoute>.
// Reuses the shared Layout + Sidebar shell so it feels like the rest of the
// internal product.

import { Sparkles } from 'lucide-react';

import { GlobalSearchBar } from '../global-search';
import { Layout, Sidebar } from '../../shared/ui';
import { ProDriftAuditorDashboard } from './ProDriftAuditorDashboard';

export const ProDriftAuditorPage = () => (
    <Layout
        sidebar={<Sidebar />}
        title="My Portfolio Auditor PRO"
        subtitle="Institutional tax-lot, cash-flow and Forge Ultra regime-aware drift & rebalancing intelligence."
    >
        {/* Platform-wide asset search — sits directly below the page title /
            subtitle so the user can jump to any deep-dive from here. */}
        <div className="mb-6">
            <GlobalSearchBar />
        </div>

        <div className="mb-5 flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-indigo-600 to-violet-600 px-3 py-1 text-[11px] font-black uppercase tracking-wider text-white shadow-lg shadow-indigo-500/30">
                <Sparkles className="h-3.5 w-3.5" /> PRO · Unlocked
            </span>
            <span className="text-sm text-slate-500 dark:text-slate-400">
                Replay your exact book through six disciplines and act on live Forge Ultra trade tickets.
            </span>
        </div>

        <ProDriftAuditorDashboard />
    </Layout>
);
